module.exports = __webpack_public_path__ + "img/UTFRON-2.6b70edd2.jpg";